import { Observable } from 'rxjs';

export const fromMutationObserver = (target: Node, config: MutationObserverInit | undefined): Observable<MutationRecord[]> => {
    return new Observable<MutationRecord[]>(observer$ => {
       const mutation = new MutationObserver((mutations) => observer$.next(mutations));
       mutation.observe(target, config);
       return () => mutation.disconnect();
    })
   }